// extracted by mini-css-extract-plugin
export var learnMore = "learn-more-module--learnMore--1LpJn";
export var section = "learn-more-module--section--2lOe5";
export var sectionInner = "learn-more-module--sectionInner--J5erd";
export var mediaContainer = "learn-more-module--mediaContainer--3IWCt";
export var media = "learn-more-module--media--1xjBm";
export var sectionContent = "learn-more-module--sectionContent--3TVpA";
export var sectionCopy = "learn-more-module--sectionCopy--3XOGf";
export var sectionLink = "learn-more-module--sectionLink--2W3dz";